module.exports = __webpack_public_path__ + "fonts/AvenirLTW02-35Light.23141d8099ebecd12092d5dff2c53776.woff";